import { LLM } from '@/types'
import i18next from 'i18next'

import { CATEGORIES } from '../categories'

const GOOGLE_PLATORM_LINK = 'https://ai.google.dev/'

// Google Models (UPDATED 09/30/26) -----------------------------
// Current: Gemini 3.8/3.5 Flash, 3.1 Pro, 2.5 Pro/Flash.
// Gemini 1.5 and 2.0 Flash are shut down — omitted from the picker list.

const GEMINI_3_8_FLASH: LLM = {
  modelId: 'gemini-3.8-flash',
  modelName: 'Gemini 3.8 Flash',
  provider: 'google',
  hostedId: 'gemini-3.8-flash',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  new: true,
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.MULTIMODAL
  ],
  description: () =>
    i18next.t(
      'models.providers.google.gemini_3_8_flash.description',
      'Latest Gemini Flash — fast multimodal model for high-volume tasks.'
    )
}

const GEMINI_3_5_FLASH: LLM = {
  modelId: 'gemini-3.5-flash',
  modelName: 'Gemini 3.5 Flash',
  provider: 'google',
  hostedId: 'gemini-3.5-flash',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  new: true,
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.MULTIMODAL
  ],
  description: () =>
    i18next.t(
      'models.providers.google.gemini_3_5_flash.description',
      'Gemini 3.5 Flash — strong speed/quality balance for everyday multimodal work.'
    )
}

const GEMINI_3_1_PRO: LLM = {
  modelId: 'gemini-3.1-pro-preview',
  modelName: 'Gemini 3.1 Pro',
  provider: 'google',
  hostedId: 'gemini-3.1-pro-preview',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  new: true,
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ],
  description: () =>
    i18next.t(
      'models.providers.google.gemini_3_1_pro.description',
      'Current Gemini Pro preview — advanced multimodal reasoning.'
    )
}

const GEMINI_3_PRO_IMAGE: LLM = {
  modelId: 'gemini-3-pro-image-preview',
  modelName: 'Gemini 3 Pro Image',
  provider: 'google',
  hostedId: 'gemini-3-pro-image-preview',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  new: true,
  categories: [CATEGORIES.CREATIVE, CATEGORIES.IMAGE_GENERATION, CATEGORIES.MULTIMODAL],
  description: () => i18next.t('models.providers.google.gemini_3_pro_image.description')
}

const GEMINI_2_5_PRO: LLM = {
  modelId: 'gemini-2.5-pro',
  modelName: 'Gemini 2.5 Pro',
  provider: 'google',
  hostedId: 'gemini-2.5-pro',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ],
  description: () =>
    i18next.t(
      'models.providers.google.gemini_2_5_pro.description',
      'Gemini 2.5 Pro — stable prior-gen Pro with adaptive thinking.'
    )
}

const GEMINI_2_5_FLASH: LLM = {
  modelId: 'gemini-2.5-flash',
  modelName: 'Gemini 2.5 Flash',
  provider: 'google',
  hostedId: 'gemini-2.5-flash',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ],
  description: () =>
    i18next.t(
      'models.providers.google.gemini_2_5_flash.description',
      'Gemini 2.5 Flash — prior-gen Flash for low-latency reasoning.'
    )
}

const GEMMA_3_27B: LLM = {
  modelId: 'gemma-3-27b-it',
  modelName: 'Gemma 3 27B Instruct',
  provider: 'google',
  hostedId: 'gemma-3-27b-it',
  platformLink: GOOGLE_PLATORM_LINK,
  imageInput: false,
  tier: 'pro',
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ],
  description: () => i18next.t('models.providers.google.gemma_3_27b.description')
}

export const GOOGLE_LLM_LIST: LLM[] = [
  GEMINI_3_8_FLASH,
  GEMINI_3_5_FLASH,
  GEMINI_3_1_PRO,
  GEMINI_3_PRO_IMAGE,
  GEMINI_2_5_PRO,
  GEMINI_2_5_FLASH,
  GEMMA_3_27B
]
